var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { isItemAllowed, useLiFi, useWidgetConfig } from '../providers';
import { useChains } from './useChains';
import { useFeaturedTokens } from './useFeaturedTokens';
export const useTokens = (selectedChainId) => {
    var _a, _b, _c, _d;
    const lifi = useLiFi();
    const { getChainById, isLoading: isSupportedChainsLoading } = useChains();
    const featuredTokens = useFeaturedTokens(selectedChainId);
    const { tokens, chains, disabledChains } = useWidgetConfig();
    const { data, isLoading } = useQuery([
        'tokens',
        selectedChainId,
        featuredTokens === null || featuredTokens === void 0 ? void 0 : featuredTokens.length,
        (_a = tokens === null || tokens === void 0 ? void 0 : tokens.allow) === null || _a === void 0 ? void 0 : _a.length,
        (_b = tokens === null || tokens === void 0 ? void 0 : tokens.deny) === null || _b === void 0 ? void 0 : _b.length,
        (_c = chains === null || chains === void 0 ? void 0 : chains.allow) === null || _c === void 0 ? void 0 : _c.length,
        (_d = chains === null || chains === void 0 ? void 0 : chains.deny) === null || _d === void 0 ? void 0 : _d.length,
    ], () => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f, _g, _h, _j;
        const chainAllowed = selectedChainId &&
            getChainById(selectedChainId) &&
            isItemAllowed(selectedChainId, chains, disabledChains);
        if (!chainAllowed) {
            return [];
        }
        let filteredTokens = (_e = tokens === null || tokens === void 0 ? void 0 : tokens.allow) === null || _e === void 0 ? void 0 : _e.filter((token) => token.chainId === selectedChainId);
        if (!(filteredTokens === null || filteredTokens === void 0 ? void 0 : filteredTokens.length)) {
            const data = yield lifi.getTokens({ chains: [selectedChainId] });
            filteredTokens = (_f = data.tokens) === null || _f === void 0 ? void 0 : _f[selectedChainId];
        }
        const deniedTokenAddresses = (_g = tokens === null || tokens === void 0 ? void 0 : tokens.deny) === null || _g === void 0 ? void 0 : _g.filter((token) => token.chainId === selectedChainId).map((token) => token.address);
        if (deniedTokenAddresses === null || deniedTokenAddresses === void 0 ? void 0 : deniedTokenAddresses.length) {
            filteredTokens = filteredTokens === null || filteredTokens === void 0 ? void 0 : filteredTokens.filter((token) => !deniedTokenAddresses.includes(token.address));
        }
        const featuredTokenAddresses = new Set(featuredTokens === null || featuredTokens === void 0 ? void 0 : featuredTokens.map((token) => token.address));
        return [
            ...((_h = featuredTokens === null || featuredTokens === void 0 ? void 0 : featuredTokens.map((token) => {
                token.featured = true;
                return token;
            })) !== null && _h !== void 0 ? _h : []),
            ...((_j = filteredTokens === null || filteredTokens === void 0 ? void 0 : filteredTokens.filter((token) => !featuredTokenAddresses.has(token.address))) !== null && _j !== void 0 ? _j : []),
        ];
    }), {
        enabled: !isSupportedChainsLoading,
    });
    return {
        tokens: data,
        isLoading,
    };
};
